import { RefreshCw } from 'lucide-react';
import { cn } from '@jeraisonne/ui';

/**
 * Bouton « Actualiser » du Feed. Zone de tap 44 px (règle mobile-first) ;
 * l'icône tourne pendant le rechargement et le bouton reste en place (pas de
 * changement de largeur qui ferait sauter l'en-tête).
 */
export function FeedRefreshButton({
  onRefresh,
  isRefreshing,
  className,
}: {
  onRefresh: () => void | Promise<void>;
  isRefreshing: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={() => void onRefresh()}
      disabled={isRefreshing}
      aria-label="Actualiser le fil"
      aria-busy={isRefreshing}
      className={cn(
        'border-ink-200 text-ink-700 hover:bg-ink-50 ocean:bg-[#0b1e44] inline-flex min-h-11 min-w-11',
        'items-center justify-center gap-1.5 rounded-xl border bg-white px-3 text-[13px] font-semibold',
        'active:scale-[0.98] disabled:opacity-60',
        className,
      )}
    >
      <RefreshCw className={cn('h-4 w-4', isRefreshing && 'animate-spin')} aria-hidden />
      <span className="hidden sm:inline">{isRefreshing ? 'Actualisation…' : 'Actualiser'}</span>
    </button>
  );
}
